import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef, useContext } from 'react';
import { PANEL } from './constants.js';
import { TabsContext } from './context.js';
import { TabButton } from './styles.js';

const Tab = forwardRef((_a, ref) => {
    var { children, tabKey, onClick, setFocusedTabIndex } = _a, rest = __rest(_a, ["children", "tabKey", "onClick", "setFocusedTabIndex"]);
    const ctx = useContext(TabsContext);
    const isActive = ctx.currentTab === tabKey;
    const tabId = `${tabKey}`;
    const panelId = `${PANEL}${tabKey}`;
    const handleClick = () => {
        var _a;
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx.onChange) === null || _a === void 0 ? void 0 : _a.call(ctx, tabKey);
        setFocusedTabIndex === null || setFocusedTabIndex === void 0 ? void 0 : setFocusedTabIndex();
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (React.createElement(TabButton, Object.assign({}, rest, { "data-testid": `united-tabv2-${tabId}-${isActive ? 'active' : 'inactive'}`, ref: ref, id: tabId, isActive: isActive, onClick: handleClick, role: "tab", tabIndex: isActive ? 0 : -1, "aria-selected": isActive, "aria-controls": panelId }), children));
});
Tab.displayName = 'Tab';

export { Tab as default };
